import { literal, nativeEnum, string, TypeOf } from 'zod';

import { BaseProduct } from './base';
import { LiveEventStatus, ProductType } from './types';

/* ---------------------------- LiveEvent Product --------------------------- */

export const LiveEventProduct = BaseProduct.extend({
    type: literal(ProductType.LiveEvent),
    eventStatus: nativeEnum(LiveEventStatus),
    eventStartTime: string().optional(),
});
export type LiveEventProduct = TypeOf<typeof LiveEventProduct>;
